// extracted by mini-css-extract-plugin
export default {"FooterWrapper":"FooterComponent_FooterWrapper__nqNVy","Footer":"FooterComponent_Footer__SnxeN"};